module.exports = __webpack_public_path__ + "83868b2687c4ad9c66f0ad8bbefc9bce.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/ork-320.webp.png
// module id = 482
// module chunks = 0